<template>
<div class="form-group">
  <label v-if="title">{{ title }}</label>
  <div class="input-group">
    <vSelect
      :placeholder="placeholder"
      v-model="selectedValue"
      :options="options"
      :disabled="disabled"
      :multiple="multiple"
      :clearable="clearable"
      :reduce="option => option[trackBy]"
      @input="emitInput"
    >
      <template #no-options>No se encontraron opciones</template>
    </vSelect>
    <span class="invalid-feedback" role="alert" :class="{ 'd-block' : hasErrors }">
        <strong>{{ errors[0] }}</strong>
    </span>
  </div>
</div>
</template>

<script>
import vSelect from 'vue-select'
import "vue-select/dist/vue-select.css";

export default {
    components: { vSelect },
    props: {
        multiple: {
            type: Boolean,
            default: false,
        },
        clearable: {
            type: Boolean,
            default: false,
        },
        trackBy: {
            type: String,
            default: "id",
        },
        label: {
            type: String,
            default: "label",
        },
        value: {
            type: [Object, Array, String, Number, Boolean, Date, Function, Symbol, undefined, null],
            default: null,
        },
        options: {
            type: Array,
            default: () => [],
        },
        disabled: {
            type: Boolean,
            deafult: false,
        },
        placeholder: {
            type: String,
            default: "Seleccione",
        },
        title: {
            type: String,
            default: "",
        },
        errors: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        selectedValue: {
            get() {
                return this.value;
            },
            set(newValue) {
                this.$emit("input", newValue);
            },
        },
        hasErrors() {
            return this.errors.length > 0;
        },
    },
    methods: {
        emitInput(value) {
            this.$emit("input", value);
        },
    },
};
</script>


<style>
  .v-select {
    width: 100%;
  }
</style>